import _ from "lodash";
import {
  accumulateValuesFn,
  dataKeyForPayerType,
  payersNoun,
} from "../../utilities/charts/chart_utils";
import showPayersModal from "../../utilities/charts/payers_modal";
import PayersLivesDonutChartBase from "./payers_lives_donut_chart_base";

export default class extends PayersLivesDonutChartBase {
  calculateFractions(coverageMetric) {
    let present = 0;

    let total = 0;

    _.forIn(_.pick(this.params.data[this.drug], this.payerTypesShown), (values, payerType) => {
      const allValues = _.values(values);
      const presentValues = _.values(_.omit(values, ""));

      const accumulate = accumulateValuesFn(payerType, coverageMetric);

      total += _.sum(allValues.map(accumulate));
      present += _.sum(presentValues.map(accumulate));
    });

    const mainFraction = total === 0 ? 0 : present / total;

    return {
      mainFraction,
      increaseFraction: 0,
      decreaseFraction: 0,
    };
  }

  triggerModalInternal(collection) {
    const withPublishedPolicy = collection !== "remainder";

    const payerTypes = this.payerTypesShown.map(dataKeyForPayerType);

    const payers = _.mapValues(_.pick(this.params.data[this.drug], payerTypes), valuesByType => {
      const dataset = withPublishedPolicy ? _.omit(valuesByType, "") : _.pick(valuesByType, "");

      return _.flatten(_.values(dataset));
    });

    const verb = withPublishedPolicy ? "with" : "without";
    const title = `${payersNoun(payerTypes)} ${verb} Published Policy for ${this.drug}`;

    showPayersModal(this.drug, title, payers);
  }

  get titleText() {
    const nouns = payersNoun(this.payerTypesShown);

    return `${nouns} & Lives with Published Policies for ${this.drug}`;
  }

  get tooltipTitleText() {
    return "Has Published Policy";
  }
}
